import React from 'react';
import PropTypes from 'prop-types';
import GroupSearch from 'components/common/GroupSearch';

const AgentFilter = ({ handleChange, organizationId }) => (
  <GroupSearch
    label="Group Name"
    name="search"
    form={{}}
    handleChange={handleChange}
    organizationId={organizationId}
    error={false}
  />
);

AgentFilter.defaultProps = {
  organizationId: null,
};

AgentFilter.propTypes = {
  handleChange: PropTypes.func.isRequired,
  organizationId: PropTypes.number,
};

export default AgentFilter;
